export const FURROW_REGANTO_REQUEST = "FURROW_REGANTO_REQUEST";
export const FURROW_REGANTO_SUCCESS = "FURROW_REGANTO_SUCCESS";
export const FURROW_REGANTO_FAILED = "FURROW_REGANTO_FAILED";
